import React, { Fragment, useState } from 'react';
import { Link, withRouter } from 'react-router';
import { useSnackbar } from 'notistack';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { read, utils } from 'xlsx';
import { Button, Dialog, Grid, TextField, DialogActions, DialogContent, DialogTitle, Table, TableHead, TableBody, TableCell, CircularProgress, TableRow, Tabs, Tab, Paper, Tooltip } from '@material-ui/core';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { globalExportService, globalGetService, globalPostService } from '../../../utils_v2/globalApiServices';
import { checkApiStatus, downloadFileType, onCheckPermission } from '../../../utils_v2';
import { regexConstants } from '../../../constants/regEx';
import { DropzoneArea } from 'material-ui-dropzone';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import { backendDateFormat, fieldDateFormat } from '../../../constants';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import AddIcon from '@material-ui/icons/Add';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
const ImportCertficateTemplate = ({ params, getResponseBack }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [tabIndex, setTabIndex] = useState(0);
    const [modal, setModal] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [importCrud, setImportCrud] = useState({ template: null });
    const [templates, setTemplates] = useState([])
    const [pres, setPres] = useState([]);
    const [error, setError] = useState({});
    const getFormTemplates = () => {
        globalGetService(`technical/templates/?asset_type=${params.type}`, { type: 'T014' })
            .then(response => {
                if (checkApiStatus(response)) {
                    setTemplates(response.data.data.list)
                }
            })
    }

    const normalizeYear = (value, returnFormat = 'date') => {
        if (!value) return null;
        let dateObj = null;
        if (typeof value === 'number') {
            dateObj = new Date(Math.round((value - 25569) * 86400 * 1000));
        }
        if (typeof value === 'string') {
            const m = moment(value, ['DD/MM/YYYY', 'DD-MM-YYYY', 'DD/MM/YY', 'DD-MM-YY'], true);
            if (m.isValid()) {
                dateObj = m.toDate();
            }
        }
        if (!dateObj) return null;
        if (returnFormat === 'string') {
            return moment(dateObj).format('YYYY-MM-DD');
        }
        return dateObj;
    };
    const expectedFileHeaders = ['Certificate Name', 'Issue Date', 'Expiry Date', 'Remarks'];
    const onChangeTemplate = (template) => {
        setImportCrud({ template });
        setLoading(true);
        if (template) {
            (async () => {
                const f = await (await fetch(template.file_path)).arrayBuffer();
                const wb = read(f);
                const ws = wb.Sheets['Certificate'];
                const data = utils.sheet_to_json(ws, { blankRows: false });
                const headers = Object.keys(data[0] || {});
                const validFile = expectedFileHeaders.some(header => headers.includes(header));
                if (!validFile) {
                    enqueueSnackbar('Unable to Import the file . Please check for exact column names as per sample template & data exists in the sheet', { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' }, autoHideDuration: 9000 });
                    setPres([]);
                    setLoading(false);
                    return;
                }
                const updatedData = data.map(row => ({
                    name: row['Certificate Name'] || '',
                    issue_date: row['Issue Date'] ? normalizeYear(row['Issue Date'], 'string') : null,
                    expiry_date: row['Expiry Date'] ? normalizeYear(row['Expiry Date'], 'string') : null,
                    remarks: row['Remarks'] || '',
                }));
                setPres(updatedData);
                setLoading(false);
            })()
        } else {
            setPres([]);
            setLoading(false);
        }
    }
    const onFieldChange = (e, keyParam, value, index) => {
        setPres(pres.map((item, itemIndex) => itemIndex !== index ? item : { ...item, [keyParam]: value }))
    }
    const onRemove = (index) => {
        setPres(pres.filter((item, itemIndex) => itemIndex !== index))
    }

    const onSetupTemplate = () => {
        let validationInputs = {};
        pres.forEach((row, index) => {
            validationInputs[index] = {};

            if (!row.name || row.name.trim() === '') {
                validationInputs[index].name = 'Please enter Name';
            }
            if (!row.issue_date) {
                validationInputs[index].issue_date = 'Please enter Issue Date';
            } else if (!moment(row.issue_date).isValid()) {
                validationInputs[index].issue_date = 'Enter valid Issue Date';
            } else if (moment(row.issue_date).isAfter(moment())) {
                validationInputs[index].issue_date = "Issue Date can't be future date";
            }

            if (row.expiry_date && !moment(row.expiry_date).isValid()) {
                validationInputs[index].expiry_date = 'Enter valid Expiry Date';
            }

            if (row.issue_date && row.expiry_date && moment(row.expiry_date).isBefore(moment(row.issue_date))) {
                validationInputs[index].expiry_date = 'Expiry date cannot be lesser than Issue Date';
            }
        });
        if (Object.values(validationInputs).every((row) => Object.keys(row).length === 0)) {
            setLoading(true);
            globalPostService(`technical/workorder/${params.workOrderSlug}/t014/certificates/?type=T014&asset_type=${params.type}`, { certificates: pres })
                .then(response => {
                    setLoading(false);
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } })
                        getResponseBack();
                        setModal(false);
                        setImportCrud({ template: null });
                        setPres([]);
                    } else {
                        enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' }, autoHideDuration: 9000 })
                    }
                })
        } else {
            setError(validationInputs)
        }
    }
    const downloadSampleTemplate = () => {
        globalExportService(`technical/workorder/t014/sampleDownloadCertificate`)
            .then(response => {
                downloadFileType(response, 'T014_Certificate_Sample_Template.', 'xls')
            })
    }
    const handleFile =
        async (files) => {
            if (files.length === 0) return;
            setLoading(true);
            const file = files[0];
            const data = await file.arrayBuffer();
            const wb = read(data);
            const ws = wb.Sheets['Certificate'];
            const jsonData = utils.sheet_to_json(ws, { blankRows: false });
            const headers = Object.keys(jsonData[0] || {});
            const validFile = expectedFileHeaders.some(header => headers.includes(header));
            if (!validFile) {
                enqueueSnackbar('Unable to Import the file . Please check for exact column names as per sample template & data exists in the sheet', { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' }, autoHideDuration: 9000 });
                setPres([]);
                setLoading(false);
                return;
            }
            const updatedData = jsonData.map(row => ({
                name: row['Certificate Name'] || '',
                issue_date: row['Issue Date'] ? normalizeYear(row['Issue Date'], 'string') : null,
                expiry_date: row['Expiry Date'] ? normalizeYear(row['Expiry Date'], 'string') : null,
                remarks: row['Remarks'] || '',
            }));
            setPres(updatedData);
            setLoading(false)
        }
    return (
        <Fragment>

            <Button onClick={() => { getFormTemplates(); setModal(true); setTabIndex(0) }} color='primary' variant='outlined' size='small'><AddIcon color='primary' style={{ fontSize: '1.15rem' }} />Import Template</Button>
            {modal ?
                <Dialog
                    open={modal}
                    onClose={() => { setModal(false) }}
                    className=' project-modal'
                    maxWidth={false}
                >
                    <DialogTitle id="scroll-dialog-title">
                        Import Template
                    </DialogTitle>
                    <DialogContent dividers={true} style={{ padding: '8px' }} >
                        <div style={{ width: '780px', minHeight: '400px' }}>
                            <Paper>
                                <Tabs
                                    value={tabIndex}
                                    onChange={(event, newValue) => { setPres([]); setTabIndex(newValue); setImportCrud({ template: null }) }}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    variant="fullWidth"
                                >
                                    <Tab label={<span>Custom Template</span>} />
                                    <Tab label={<span>Excel Import</span>} />
                                </Tabs>
                            </Paper>
                            {tabIndex === 0 ?
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={6}>
                                        <Autocomplete
                                            options={templates}
                                            getOptionLabel={option => option.name}
                                            id="template"
                                            value={importCrud.template}
                                            onChange={(e, value) => onChangeTemplate(value)}
                                            renderInput={params => <TextField required {...params} label="Select Template" margin="normal" fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                        />
                                    </Grid>
                                    {onCheckPermission('project_management', 'template', 'C') ?
                                        <Grid item sm={6} style={{ padding: '20px 0px 0px 7px' }} >
                                            or &nbsp;
                                            <Link to='/technical/form/templates/'>
                                                <Button variant='contained' color='primary' ><AddIcon style={{ fontSize: '1.15rem', color:'#fff' }} />
                                                    Add New Template
                                                </Button>
                                            </Link>
                                        </Grid>
                                        : null}
                                </Grid> :
                                <div>
                                    <div >
                                        {!pres.length ? <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
                                            <span> Refer the sample template </span>
                                            <Button style={{ fontFamily: '"Conv_IBMPlexSans-Bold"', fontWeight: '700' }} size='small' color='primary' variant='text' aria-controls="simple-menu" aria-haspopup="true" onClick={downloadSampleTemplate} endIcon={<ArrowDropDownIcon fontSize='small' />}> Download </Button>
                                        </div> : null}
                                        {!pres.length ?
                                            <DropzoneArea
                                                acceptedFiles={['.xls, .xlsx,']}
                                                filesLimit={1}
                                                maxFileSize={104857600}
                                                showPreviewsInDropzone={false}
                                                useChipsForPreview={true}
                                                showPreviews={true}
                                                dropzoneText={<p style={{ fontSize: '13px' }}>Drag & Drop Documents<br /> OR <br /> Click Here<br /> </p>}
                                                dropzoneClass="drag-drop-cnt"
                                                maxWidth="xl"
                                                showAlerts={['info', 'error']}
                                                alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                                                clearOnUnmount={true}
                                                onChange={(files) => handleFile(files)}
                                            /> : null}
                                    </div>
                                    {!pres?.length ? <span  className='attachment-note' > Note : Supported extension ('.xls, .xlsx').</span> : null}
                                </div>
                            }
                            <Grid container spacing={1}>
                                {
                                    isLoading ?
                                        <Grid item sm={12}>
                                            <div style={{ textAlign: 'center', marginTop: '45px' }} >
                                                <CircularProgress size={40} />
                                            </div>
                                        </Grid> : null
                                }
                                <Grid item md={12} style={{ marginTop: tabIndex === 1 ? '5px' : '' }}>
                                    {pres.length ?
                                        <Table className='mui-table-format'>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Certificate Name</TableCell>
                                                    <TableCell>Issue Date</TableCell>
                                                    <TableCell>Expiry Date</TableCell>
                                                    <TableCell>Remarks</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {pres.map((pres, index) => (
                                                    <TableRow>
                                                        <TableCell>
                                                            <TextField
                                                                id={`name_${index}`}
                                                                value={pres.name}
                                                                fullWidth
                                                                margin="normal"
                                                                onChange={(e) => { onFieldChange(e, 'name', e.target.value, index); setError(prevError => ({ ...prevError, [index]: { ...prevError[index], name: '' } })); }}
                                                                InputLabelProps={{ shrink: true }}
                                                                variant='outlined'
                                                                style={{ marginTop: '0px' }}
                                                                error={!!error[index]?.name}
                                                                helperText={error[index]?.name || ''}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                                                <KeyboardDatePicker
                                                                    margin="normal"
                                                                    id={`issue_date_${index}`}
                                                                    name="issue_date"
                                                                    format={fieldDateFormat}
                                                                    fullWidth
                                                                    disableFuture
                                                                    InputLabelProps={{ shrink: true }}
                                                                    maxDate={moment()}
                                                                    minDate={moment().subtract(25, 'years')}
                                                                    value={pres?.issue_date || null}
                                                                    onChange={(data, e) => { onFieldChange(e, 'issue_date', moment(data).format(backendDateFormat), index); setError(prevError => ({ ...prevError, [index]: { ...prevError[index], issue_date: '' } })); }}
                                                                    inputVariant='outlined'
                                                                    error={!!error[index]?.issue_date}
                                                                    helperText={error[index]?.issue_date || ''}
                                                                    style={{ marginTop: '0px' }}
                                                                />
                                                            </MuiPickersUtilsProvider>
                                                        </TableCell>
                                                        <TableCell>
                                                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                                                <KeyboardDatePicker
                                                                    id={`expiry_date_${index}`}
                                                                    margin="normal"
                                                                    name="expiry_date"
                                                                    format={fieldDateFormat}
                                                                    fullWidth
                                                                    InputLabelProps={{ shrink: true }}
                                                                    minDate={moment().subtract(25, 'years')}
                                                                    value={pres?.expiry_date || null}
                                                                    onChange={(data, e) => { onFieldChange(e, 'expiry_date', moment(data).format(backendDateFormat), index); setError(prevError => ({ ...prevError, [index]: { ...prevError[index], expiry_date: '' } })); }}
                                                                    inputVariant='outlined'
                                                                    error={!!error[index]?.expiry_date}
                                                                    helperText={error[index]?.expiry_date || ''}
                                                                    style={{ marginTop: '0px' }}
                                                                />
                                                            </MuiPickersUtilsProvider>
                                                        </TableCell>
                                                        <TableCell>
                                                            <TextField
                                                                name='remarks'
                                                                id={`remarks_${index}`}
                                                                value={pres?.remarks || ''}
                                                                fullWidth
                                                                margin="normal"
                                                                onChange={(e) => onFieldChange(e, 'remarks', e.target.value, index)}
                                                                variant='outlined'
                                                                style={{ marginTop: '0px' }}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            {pres.length !== 1 ?
                                                                <Tooltip title='Delete' arrow><DeleteOutlineIcon color='secondary' onClick={() => onRemove(index)} style={{cursor:'pointer'}} /></Tooltip> : null
                                                            }
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                                }
                                            </TableBody>
                                        </Table> : null
                                    }
                                </Grid>
                            </Grid>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button disabled={isLoading} onClick={() => { setModal(false); setPres([]); setImportCrud({ template: null }) }} color="primary" size='small' variant='outlined'>Cancel</Button>
                        {pres.length ?
                            <Button disabled={isLoading} onClick={onSetupTemplate} color="primary" size='small' variant='contained'>
                                {isLoading ? <CircularProgress size={20} /> : 'Proceed'}
                            </Button> : null
                        }
                    </DialogActions>
                </Dialog> : null
            }
        </Fragment>
    )
}
export default withRouter(ImportCertficateTemplate);